<template>
  <section class="content_section">
    <SimpleList v-if="this.isLoaded" :serverside="true" @filter="getFiltered"
                @select="selectClients" :clientSource="'getAllClients'"
                :data="clients" :options="options" :isClients="true" :title=options.Lang.Aktive_Mandanten :defaultCount="defaultCount" :cols="cols" :hideCols="hideCols"
                :emptyState=options.Lang.Keine_Mandanten_vorhanden :buttonText=options.Lang.Neuen_Mandanten_anlegen buttonAction="Client"
                :actions="actions" :clean="false" @updateData="getAll()"></SimpleList>
    <FormImportTrip @updateData="getAll()" v-if="options.showImportTripForm && options.user.loggedIn"
                    :currentTrip="options.currentTrip" :options="options"></FormImportTrip>
    <FormClient @updateData="getAll()" v-if="options.showClientForm && options.user.loggedIn"
                :currentClient="options.currentClient" :options="options"></FormClient>
    <FormUser @updateData="getAll()" v-if="options.showUserForm && options.user.loggedIn"
              :currentFormUser="options.currentFormUser" :options="options"></FormUser>
  </section>
</template>
<script>

import SimpleList from "@/components/lists/SimpleList";
import FormUser from "@/components/dialogs/FormUser";
import FormClient from "@/components/dialogs/FormClient";
import FormImportTrip from "@/components/dialogs/FormImportTrip";

const toLower = text => {
  if (text !== null) {
    return text.toString().toLowerCase()
  } else {
    return "";
  }
}

export default {
  name: 'clients',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    FormClient,
    FormImportTrip
  },
  data() {
    return {
      defaultCount: null,
      search: null,
      searchedUsers: [],
      selectedClients: [],
      clients: [],
      hideCols: [],
      cols: ['kunden_nr', 'firma', 'tools', 'users'],
      isLoaded: false,
      actions: [
        {
          icon: 'note_alt',
          action: 'editClient',
          title: 'Kunde bearbeiten'
        },
        {
          icon: 'manage_accounts',
          action: 'editUsers',
          title: this.options.Lang.Benutzer_bearbeiten
        },
        {
          icon: 'move_to_inbox',
          action: 'archivClient',
          title: 'Mandanten ins Archiv verschieben'
        },
        {
          icon: 'logout',
          action: '???',
          title: '???'
        }
      ],
    };
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  mounted(){
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
    let self = this;
    self.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
       
        const parsedValue = parseInt(result.defaultCount, 10);

// Überprüfe, ob parsedValue eine ganze Zahl ist
if (!isNaN(parsedValue)) {
  self.defaultCount = parsedValue;
} else {
  self.defaultCount = 10;
}


      }
    });
  },
  created() {
    this.options.isUploading = true;
    this.getAll();
  },
  methods: {
    getAll() {
      let self = this;
      self.isLoaded = false;
      self.options.isUploading = true;
      this.doPost({userdata: self.options.user}, 'getAllClients', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.clients = values;
           
            for (let i = 0; i < self.clients.length; i++) {
              self.clients[i].tools = '<span class="list_check_icons"><md-icon class="' + (self.clients[i].webuser ? 'green' : 'red') + '">done</md-icon><md-icon class="' + (self.clients[i].piwik_token && self.clients[i].piwik_id ? 'green' : 'red') + '">done</md-icon></span>'
            }
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
    getFiltered(args) {
      let self = this;
      self.options.isUploading = true;
      let where = args && args.where ? args.where : null;
      let order = args && args.order ? args.order : null;
      this.doPost({
        userdata: self.options.user,
        data: {
          where: where,
          sort: order
        }
      }, 'getAllClients', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.clients = values;
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
    selectClients(clients) {
      this.selectedClients = clients;
    }
  }
};
</script>